import pino from 'pino';

const pushToGTM = (logObj: object) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer.push(logObj);
};

export const logGTM = (level: pino.Level, logObj: object) => {
  switch (level) {
    case 'fatal':
    case 'error':
    case 'warn':
    case 'info':
      pushToGTM(logObj);
      break;
    case 'debug':
    case 'trace':
    default:
      break;
  }
};
